import Api from '@/services/PublicApi'

export default {

  getTrackingNumber(plentyId) {
    return Api().post("plenty/order/shipped/" + plentyId)
  }

}